// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1561":"73c4d07b28723e3171bf","2888":"c4d8377f5ea810df4331","6233":"73c4d07b28723e3171bf","6604":"73c4d07b28723e3171bf"}[chunkId] + ".css";
};